module.exports = __webpack_public_path__ + "static/media/lanna-gard.2ffbc7bc.svg";